



  import {Component, Vue, Prop, Watch} from "vue-property-decorator";
import InlineSvg from 'vue-inline-svg';
import Icons from './icons'

@Component({
  components: {InlineSvg}
})
export default class SvgRender extends Vue {
  @Prop(String) name!: string
  @Prop(Number) width?: number
  @Prop(Number) height?: number

  private icon = this.getIcon(this.name)

  @Watch('name', { immediate: true, deep: true })
  onNameChange(name: string) {
    this.icon = this.getIcon(name)
  }

  get iconSrc(): string {
    if (this.icon) return this.icon.src()
    return ''
  }

  get iconWidth(): number {
    if (this.width) return this.width
    if (this.icon) return this.icon.width
    return 0
  }

  get iconHeight(): number {
    if (this.height) return this.height
    if (this.icon) return this.icon.height
    return 0
  }

  onClickToSvg(): void {
    this.$emit('click')
  }

  getIcon(name:string):any {
    return Icons.find(o => o.name === name)
  }
}
